import { permissionCheckFnforCamo } from "../utils";
import {PageNotFound} from "../shared_elements";
export default function userRoleBaseAccessHoc(HocComponent, extraProps) {
	if (permissionCheckFnforCamo({ primaryKey: extraProps?.[0], keyIndex: extraProps?.[1] })) {
		return function (props) {
			return <HocComponent {...props} />;
		};
	} else {
		return PageNotFound;
	}
}
